// extracted by mini-css-extract-plugin
export default {"root":"_2txjs","item":"_3UqhZ"};